var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _g, _path12;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStatistics(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "growth",
    xmlns: "http://www.w3.org/2000/svg",
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_297",
    "data-name": "Ellipse 297",
    cx: 256,
    cy: 256,
    r: 256,
    fill: "#c4e6eb"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1447",
    "data-name": "Path 1447",
    d: "M126.906,343.562H38.876a14.014,14.014,0,0,0-14.019,14.009v8.586a257.046,257.046,0,0,0,116.07,118.567V357.571A14.015,14.015,0,0,0,126.906,343.562Z",
    fill: "#fe3f4e"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1448",
    "data-name": "Path 1448",
    d: "M82.892,444.567V357.572a14.014,14.014,0,0,1,14.02-14.009H38.877a14.005,14.005,0,0,0-14.02,14.009v8.586A256.752,256.752,0,0,0,82.892,444.567Z",
    fill: "#fa243a"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1449",
    "data-name": "Path 1449",
    d: "M359.046,176.29h-88.03A14.014,14.014,0,0,0,257,190.3V511.987a254.878,254.878,0,0,0,116.07-28.269V190.3A14.015,14.015,0,0,0,359.046,176.29Z",
    fill: "#97bc31"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1450",
    "data-name": "Path 1450",
    d: "M257,190.3V511.987a256.679,256.679,0,0,0,58.035-6.842V190.3a14.015,14.015,0,0,1,14.02-14.009H271.016A14.005,14.005,0,0,0,257,190.3Z",
    fill: "#87af2e"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1451",
    "data-name": "Path 1451",
    d: "M242.976,263.266h-88.03a14.014,14.014,0,0,0-14.019,14.009v207.45A254.738,254.738,0,0,0,257,511.987V277.275A14.015,14.015,0,0,0,242.976,263.266Z",
    fill: "#ffc30a"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1452",
    "data-name": "Path 1452",
    d: "M140.927,277.275v207.45a254.384,254.384,0,0,0,58.034,20.887V277.275a14.015,14.015,0,0,1,14.017-14.009c-61.245.025-58.119-.065-59.465.072A14.016,14.016,0,0,0,140.927,277.275Z",
    fill: "#ffa01a"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1453",
    "data-name": "Path 1453",
    d: "M489.135,88.437a14.015,14.015,0,0,0-14.02-14.009h-88.03a14.014,14.014,0,0,0-14.02,14.009V483.719A257.038,257.038,0,0,0,489.134,361.891C489.135,345.927,489.135,105.03,489.135,88.437Z",
    fill: "#36acb7"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1454",
    "data-name": "Path 1454",
    d: "M431.1,88.437a14.014,14.014,0,0,1,14.017-14.009c-13.523,0-57.245-.019-58.509.024a13.988,13.988,0,0,0-13.542,13.985V483.719A256.642,256.642,0,0,0,431.1,442.727V88.437Z",
    fill: "#329aa3"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1455",
    "data-name": "Path 1455",
    d: "M320.8,3.736,281.971.071a16.014,16.014,0,0,0-3.006,31.887l.091.009L62.632,208.568a16.1,16.1,0,0,0-1.691,23.348h0A15.893,15.893,0,0,0,82.7,233.493L299.757,56.4a15.89,15.89,0,0,0,1.491,8.538c7.325,14.656,28.887,10.492,30.389-5.463l3.6-38.3A16.034,16.034,0,0,0,320.8,3.736Z",
    fill: "#36acb7"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1456",
    "data-name": "Path 1456",
    d: "M333.639,12.6a16.5,16.5,0,0,0-1.4-2.324h0L299.758,37.737,61.467,232.438A15.878,15.878,0,0,0,82.7,233.493L299.757,56.4a16.014,16.014,0,1,0,31.879,3.075c3.807-40.767,3.677-38.342,3.672-39.864A15.968,15.968,0,0,0,333.639,12.6Z",
    fill: "#329aa3"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1457",
    "data-name": "Path 1457",
    d: "M443.546,430.223H68.455a257.218,257.218,0,0,0,53.258,43.752H390.288A257.186,257.186,0,0,0,443.546,430.223Z",
    fill: "#7f7e7d"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_739",
    "data-name": "Group 739"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1458",
    "data-name": "Path 1458",
    d: "M212.424,430.223H68.454a257.218,257.218,0,0,0,53.258,43.752h90.711C191.65,466.722,191.606,437.492,212.424,430.223Z",
    fill: "#666"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1459",
    "data-name": "Path 1459",
    d: "M121.713,473.975c80.469,49.681,184.843,51.694,268.575,0Z",
    fill: "#666"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1460",
    "data-name": "Path 1460",
    d: "M212.424,473.975H121.713A254.582,254.582,0,0,0,198.969,505.6,23.122,23.122,0,0,1,212.424,473.975Z",
    fill: "#5a5b5b"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatistics);
export default __webpack_public_path__ + "static/media/statistics.6469af95d168f3b41e4df0be5587dcbc.svg";
export { ForwardRef as ReactComponent };